var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flat-pickr',{attrs:{"config":_vm.config},on:{"on-change":function($event){}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }